const api = process.env.NEXT_PUBLIC_API_URL;
const next = process.env.NEXT_PUBLIC_HOST + '/api';

// paths of api call's urls
export const __API = {
    middlewares: {
        theme: `${next}/theme`,
        location: `${next}/location`,
        login: `${next}/login`,
        logout: `${next}/logout`,
    },
    register: {
        login: `${api}/account/auth/admin_login/`,
        me: `${api}/account/me/`,
        register: `${api}/account/auth/register/`,
        logout: `${api}/account/auth/logout/`,
        verify: `${api}/account/auth/verify_code/`,
    },
    posts: {
        list: `${api}/advertisement/post/approved_list/`,
        detail: (slug: string) => `${api}/advertisement/post/${slug}/approved_detail/`,
        otherOwnerApprovedList: (slug: string) => `${api}/advertisement/post/${slug}/other_owner_approved_list/`,
        detailAdmin: (slug: string) => `${api}/advertisement/post/${slug}/`,
        myPosts: `${api}/advertisement/post/my_posts/`,
        myViews: `${api}/advertisement/view/my_views/`,
        myBookmarks: `${api}/advertisement/bookmark/my_bookmarks/`,
        myPostDetail: (slug: string) => `${api}/advertisement/post/${slug}/my_posts_detail/`,
        create: `${api}/advertisement/post/user_create/`,
        update: (slug: string) => `${api}/advertisement/post/${slug}/user_update/`,
    },
    category: {
        list: `${api}/advertisement/category/`,
        detail: (slug: string) => `${api}/advertisement/category/${slug}/`,
        threeLevel: `${api}/advertisement/category/three_levels/`,
    },
    categoryField: {
        list: `${api}/advertisement/category-field/detailed_list/`,
        createBulkValues: `${api}/advertisement/field-value/user_bulk_create/`,
    },
    location: {
        list: `${api}/core/location/`,
        detail: (id: number | string) => `${api}/core/location/${id}`,
    },
    setting: {
        terms: `${api}/account/setting/detail/termsAndConditions/`,
        chatDeactivated: `${api}/account/setting/detail/chatDeactivateFeature/`,
    },
    core: {
        attachment: {
            index: `${api}/core/user/attachment/`,
            detail: (id: number | string) => `${__API.core.attachment.index}${id}/`,
        },
    },
    view: {
        myPost: `${api}/advertisement/view/my_post_views/`,
        add: `${api}/advertisement/view/`,
    },
    like: {
        add: `${api}/advertisement/like/`,
        remove: (slug: string | number) => `${api}/advertisement/like/${slug}/`,
    },
    bookmark: {
        add: `${api}/advertisement/bookmark/`,
        remove: (slug: string | number) => `${api}/advertisement/bookmark/${slug}/`,
    },
    report: {
        add: `${api}/report/`,
    },
    payment: {
        pay: `${api}/advertisement/payments/user/`,
        melatPay: `${api}/advertisement/payments/mellat/user/`,
        verify: `${api}/advertisement/payments/user/verify/`,
        bazarPay: `${api}/advertisement/payments/bazarpay/user/`,
        bazarPayVerify: `${api}/advertisement/payments/bazarpay/user/verify/`,
    },
    ticket: {
        index: `${api}/ticket/`,
        messages: `${api}/ticket/message/`,
        sendMessage: `${api}/ticket/message/send_message/`,
        create: `${api}/ticket/create_user_ticket/`,
    },
    chat: {
        index: `${api}/chat/`,
        sentList: `${api}/chat/my_chats/`,
        receivedList: `${api}/chat/my_posts_chats/`,
        messages: `${api}/chat/message/`,
        sendMessage: `${api}/chat/message/send_message/`,
        seen: (id: string | number) => `${api}/chat/${id}/seen_messages/`,
        report: `${api}/report/chat/`,
        unreadCount: `${api}/chat/message/get_unread_messages/`,
    },
};

export { __API as API };
